import * as React from "react";
import Header from "../components/header";
import ProjectsCards from "../components/projectsCards";
import Footer from "../components/footer";

const ProjectsPage = () => {
  return (
    <main style={{ backgroundColor: "#0a0a0a", minHeight: "100vh", color: "#fff" }}>
      <Header />

      <section>
        <ProjectsCards />
      </section>

      <Footer />
    </main>
  );
};

export default ProjectsPage;